export default "assets/images/flags/de-1ef5bfbb.svg";